import React from 'react';
// styles
import styled from 'styled-components';

const RepeatIcon = ({ className, ...props }) => (
  <svg
    {...props}
    aria-label="Repeat"
    className={className}
    role="img"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.49998 6.7H3.99998V4.7C3.99998 4.14771 4.44769 3.7 4.99998 3.7H16C16 2.59543 15.1045 1.7 14 1.7H4.99998C3.34312 1.7 1.99998 3.04314 1.99998 4.7V6.7H0.499979C0.0760602 6.7 -0.155518 7.19443 0.115868 7.52009L2.61587 10.5201C2.81577 10.76 3.18419 10.76 3.38409 10.5201L5.88409 7.52009C6.15548 7.19443 5.9239 6.7 5.49998 6.7ZM10.5 10.7H12V12.7C12 13.2523 11.5523 13.7 11 13.7H-2.09936e-05C-2.09936e-05 14.8046 0.895409 15.7 1.99998 15.7H11C12.6568 15.7 14 14.3569 14 12.7V10.7H15.5C15.9239 10.7 16.1555 10.2056 15.8841 9.8799L13.3841 6.8799C13.1842 6.64003 12.8158 6.64003 12.6159 6.8799L10.1159 9.8799C9.84448 10.2056 10.0761 10.7 10.5 10.7Z"
      fill="#263340"
    />
  </svg>
);

export default styled(RepeatIcon)``;
